import { assert } from '../utils';

const PRNG_MOD1 = 4294967087;
const PRNG_MUL1 = 65539;
const PRNG_MOD2 = 4294965887;
const PRNG_MUL2 = 65537;

/**
 * creates a **bad** pseudo random number generator
 */
export default class Prng {
	// https://stackoverflow.com/a/22313621/5572146

	/**
	 * @param {number} seed
	 */
	constructor(seed) {
		this.state1 = seed % (PRNG_MOD1 - 1) + 1;
		this.state2 = seed % (PRNG_MOD2 - 1) + 1;
	}

	/**
	 * @returns {number}
	 */
	next() {
		this.state1 = (this.state1 * PRNG_MUL1) % PRNG_MOD1;
		this.state2 = (this.state2 * PRNG_MUL2) % PRNG_MOD2;
		return this.state1 + this.state2;
	}

	/**
	 * @returns {string}
	 */
	color() {
		function padZero(str) {
			if (str.length === 1) {
				return `0${str}`;
			}
			return str;
		}

		const n = this.next() | 0;
		const r = (n >> 24) & 0xff;
		const g = (n >> 16) & 0xff;
		const b = (n >> 8) & 0xff;
		return `#${padZero(r.toString(16))}${padZero(g.toString(16))}${padZero(b.toString(16))}`;
	}

	/**
	 * @template T
	 * @param {Array<T>} arr
	 * @return {T | undefined}
	 */
	arrayItem(arr) {
		if (arr.length === 0) {
			return undefined;
		}
		const i = this.range(0, arr.length);
		return arr[i];
	}

	/**
	 * @template T
	 * @param {Array<T>} arr
	 */
	shuffleInplace(arr) {
		// https://stackoverflow.com/a/6274381/5572146
		for (let i = arr.length - 1; 0 < i; i -= 1) {
			const j = this.range(0, i + 1);
			[arr[i], arr[j]] = [arr[j], arr[i]];
		}
	}

	/**
	 * @return {Array<string>}
	 */
	shuffledStripesColors() {
		const colors = [
			'#ff3714',
			'#e8e800',
			'#d500d5',
		];
		this.shuffleInplace(colors);
		return colors;
	}

	/**
	 * @param {number} start
	 * @param {number} end
	 * @returns {number} [start, end) int
	 */
	range(start, end) {
		assert(start < end);
		return this.next() % (end - start) + start;
	}
}
